import React from 'react';
import { Box } from '@mui/material';

import { IItem } from 'api/catalog/models';
import NoInformationAvailable from 'ui/ErrorDisplay/NoInformationAvailable';

interface IProps {
  item?: IItem;
}

const ItemNutrition = ({ item }: IProps) => {
  if (item?.ingredients) {
    return <Box padding='20px'>{item.ingredients}</Box>;
  } else {
    return <NoInformationAvailable minHeight='300px' />;
  }
};

export default ItemNutrition;
